import { Banner } from '@dfh-corp-sites/ui'
import React from 'react'

import { Maybe, SanityContact } from '../../../groq/sanity-dispensaries/types'
import Link from '../../global/Link'

type Props = {
  practice?: Maybe<SanityContact['practice']>
}

const Meeting = ({ practice }: Props) => {
  if (!practice?.practiceInfo?.schedulingPageLink) {
    return null
  }
  return (
    <Banner
      variant="promo"
      title="We'd love to work with you."
      description="Your wellness journey is personal—get expert help tailored to you."
      primaryCtaChildren={
        <Link target="_blank" to={practice?.practiceInfo?.schedulingPageLink}>
          Schedule an appointment
        </Link>
      }
    />
  )
}

export { Meeting }
